var React = require('react');

function Equal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m64.7589 67.6633-12.256 21.228h24.512zm-44 0h88m-64.293-23.6299c0 2.522-5.372 4.567-12 4.567-6.627 0-12-2.045-12-4.567m24 6.46c0 2.523-5.372 4.568-12 4.568-6.627 0-12-2.045-12-4.568m12-11.0273c-6.627 0-12 2.045-12 4.567v12.866c0 2.522 5.373 4.567 12 4.567 6.628 0 12-2.045 12-4.567v-12.866c0-2.522-5.372-4.567-12-4.567zm76.293 4.5673c0 2.522-5.373 4.567-12 4.567s-12-2.045-12-4.567m24 6.46c0 2.523-5.373 4.568-12 4.568s-12-2.045-12-4.568m12-11.0273c-6.627 0-12 2.045-12 4.567v12.866c0 2.522 5.373 4.567 12 4.567s12-2.045 12-4.567v-12.866c0-2.522-5.373-4.567-12-4.567z","fill":"none","stroke":"#000","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"3"}));
}

Equal.defaultProps = {"height":"128","viewBox":"0 0 128 128","width":"128"};

module.exports = Equal;

Equal.default = Equal;
